// src/pages/home/WhyBizverto.jsx
import React from "react";
import "../../styles/pages/_home.css";

const items = [
  {
    title: "People-First by Design",
    desc: "We build HR systems that elevate culture, performance, and compliance.",
    icon: (
      <svg viewBox="0 0 24 24" className="why-icon" aria-hidden>
        <path d="M12 12a5 5 0 100-10 5 5 0 000 10zm-9 9a9 9 0 1118 0H3z"/>
      </svg>
    )
  },
  {
    title: "Tech That Scales",
    desc: "From websites to automation—secure, maintainable solutions that grow with you.",
    icon: (
      <svg viewBox="0 0 24 24" className="why-icon" aria-hidden>
        <path d="M3 5h18v12H3V5zm2 2v8h14V7H5zm-2 12h18v2H3v-2z"/>
      </svg>
    )
  },
  {
    title: "Strategy That Delivers",
    desc: "Lean, data-informed execution to unlock speed and measurable outcomes.",
    icon: (
      <svg viewBox="0 0 24 24" className="why-icon" aria-hidden>
        <path d="M3 13h2v8H3v-8zm8-6h2v14h-2V7zm8-4h2v18h-2V3z"/>
      </svg>
    )
  },
  {
    title: "End-to-End Partnership",
    desc: "One team across HR, IT, and business—no silos, no handoffs.",
    icon: (
      <svg viewBox="0 0 24 24" className="why-icon" aria-hidden>
        <path d="M9 7a4 4 0 118 0 4 4 0 01-8 0zM3 20a6 6 0 1112 0H3z"/>
      </svg>
    )
  },
];

export default function WhyBizverto() {
  return (
    <section className="why-section">
      <div className="why-header">
        <h2>Why Choose <span className="brand-accent">Bizverto</span>?</h2>
        <p>Clear pillars that guide how we deliver value from day one.</p>
      </div>
      <div className="why-grid">
        {items.map((it, i) => (
          <div className="why-card" key={i}>
            <div className="why-icon-wrap">{it.icon}</div>
            <h3>{it.title}</h3>
            <p>{it.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
